import Footer from '../components/Footer' 
import Navbar from '../components/navigation/Navbar' 
import React from 'react'
import { Outlet, useLocation } from 'react-router-dom'

const HIDE_NAVBAR_PATHS = [
  "/transaction",
  "/confirmation",
  "/sec/log-in",
  "/sec/create-account"
];

const PublicLayout = () => {
    const location = useLocation();
    const hideNavbar = HIDE_NAVBAR_PATHS.some(path =>
        location.pathname.startsWith(path)
    );

    return (
        <React.Fragment>
            {!hideNavbar && <Navbar />}
            <div className="content">
                <Outlet/>
            </div>
            <Footer/>
        </React.Fragment>
    )
}

export default PublicLayout
